export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "top_band": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Surtout"])},
        "band": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("min")), " – ", _interpolate(_named("max"))])},
        "unknown_band": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non classé"])}
      },
      "en": {
        "top_band": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Mostly"])},
        "band": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize([_interpolate(_named("min")), " – ", _interpolate(_named("max"))])},
        "unknown_band": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unclassified"])}
      }
    }
  })
}
